import { render, staticRenderFns } from "./CartaoObservacaoParaRevisao.vue?vue&type=template&id=14c4d0bd"
import script from "./CartaoObservacaoParaRevisao.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoObservacaoParaRevisao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports